import React from 'react';
import PolygonImg from '../assets/images/certificates/polygon.png';

export default function PolygonButton({ link }) {
    return (
        <a href={link} target="_blank">
            <img src={PolygonImg} height={17} alt="Polygon" />
        </a>
    );
}
